import { EinzaGraphiQLService } from "@/services/einzaGraphiQL"

import { calculateSummary, rearrangeAndEnrichRevenueTargetData } from "./revenueTargetByAhg"

export const admTargetRevenueStatsByArticleMainGroup = async ({ admNumber, year }) => {
  const currentYear = year && year > 0 ? year : new Date().getFullYear()
  const lastYear = currentYear - 1
  const yearBeforeLastYear = lastYear - 1

  const currentYearVariables = { admNumber, year: currentYear }
  const lastYearVariables = { admNumber, year: lastYear }
  const yearBeforeLastYearVariables = { admNumber, year: yearBeforeLastYear }
  const fields = ["articleMainGroup", "year", "revenue", "revenueTarget"]

  const graphiQLQueryObject = [
    {
      method: "currentYearRevenue: admStatsByArticleMainGroup",
      variables: currentYearVariables,
      fields,
    },
    {
      method: "lastYearRevenue: admStatsByArticleMainGroup",
      variables: lastYearVariables,
      fields,
    },
    {
      method: "yearBeforeLastYearRevenue: admStatsByArticleMainGroup",
      variables: yearBeforeLastYearVariables,
      fields,
    },
  ]
  const mappedQuery = EinzaGraphiQLService.formQuery(graphiQLQueryObject)
  const queryResponse = (await EinzaGraphiQLService.getData(mappedQuery))?.data

  if (!queryResponse) throw new Error("Data retrieval for stats projection failed")

  const { currentYearRevenue, lastYearRevenue, yearBeforeLastYearRevenue } = queryResponse

  const statsByArticleMainGroup = rearrangeAndEnrichRevenueTargetData({
    currentYearRevenue,
    lastYearRevenue,
    yearBeforeLastYearRevenue,
  })

  const summary = calculateSummary(statsByArticleMainGroup)

  return { summary: summary, admStats: statsByArticleMainGroup }
}
